import { PageRouteProps } from "../../types";

export const addressRoutes: PageRouteProps[] = [
  {
    pathName: "/address/list",
    module: ["User"],
    component: "ManageAddress",
    type: "postLogin",
    mode: "static",
  },
  {
    pathName: "/address/add",
    module: ["User"],
    component: "AddAddress",
    type: "postLogin",
    mode: "static",
  },
  {
    pathName: "/address/edit",
    module: ["User"],
    component: "AddAddress",
    type: "postLogin",
    mode: "dynamic",
  },
];
